import { MainLayout } from '@/layouts'
import { HomeScreen } from '@/screens/home'
import { NextPageWithLayout } from '@/shared/lib/next'
import { useAppShell } from '@/shared/ui/app-shell-context'
import { HomePageSeoMeta } from '@/shared/ui/seo-meta'

const MainPage: NextPageWithLayout = () => {
  const appShell = useAppShell()

  return (
    <>
      {appShell.isReady && <HomePageSeoMeta appConfig={appShell.config} />}
      <HomeScreen />
    </>
  )
}

MainPage.getLayout = (page) => <MainLayout>{page}</MainLayout>

export default MainPage
